import styled from '@emotion/styled';

const ViewWrapper = styled('section')({
  paddingTop: 48,
  paddingBottom: 36,
});

export default ViewWrapper;
